var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.type == 'dot')?_c('div',{staticClass:"red-dot dot-box",style:(_vm.style)}):(_vm.type == 'hand')?_c('div',{staticClass:"red-dot dot-hand",style:(_vm.style)}):_c('div',{staticClass:"red-dot dot-new",style:(_vm.style)})}
var staticRenderFns = []

export { render, staticRenderFns }